import { useCallback } from "react";

const STORAGE_KEY = "lead_domain";

function isStorageAvailable() {
  if (typeof window === "undefined") return false;

  try {
    const testKey = "__lead_domain_test__";
    window.sessionStorage.setItem(testKey, "1");
    window.sessionStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

export function useLeadDomain() {
  const setLeadDomain = useCallback((domain: string | null) => {
    if (!isStorageAvailable()) return;

    if (!domain) {
      window.sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    window.sessionStorage.setItem(STORAGE_KEY, domain);
  }, []);

  const getLeadDomain = useCallback(() => {
    if (!isStorageAvailable()) return null;
    return window.sessionStorage.getItem(STORAGE_KEY);
  }, []);

  return { setLeadDomain, getLeadDomain };
}
